export default () => ({
	path: 'cancel/success',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'OrderCancelSuccess',
			),
	},
});
